(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('object-test-setting', {
            parent: 'testing',
            url: '/object-test-setting?page&sort&search',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting.html',
                    controller: 'ObjectTestSettingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                search: null,
                predicates: {},
                objectTypes: {
                    id: -1,
                    objectTypeName: "All"
                },
                fleets: {
                    id: -1,
                    fleetName: "All"
                },
                testSettingTag: {
                    value : [-1]
                },
                itemsPerPageChosen: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search,
                        objectTypes: $stateParams.objectTypes,
                        fleets: $stateParams.fleets,
                        testSettingTag: $stateParams.testSettingTag
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('object-test-setting-new', {
            parent: 'object-test-setting',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-dialog.html',
                    controller: 'ObjectTestSettingDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        name: null,
                        metric: null,
                        expectedValue: null,
                        checkType: null,
                        aggregation: null,
                        timeSpan: null,
                        description: null,
                        id: null
                    };
                }
            }
        })
        .state('object-test-setting-edit', {
            parent: 'object-test-setting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-dialog.html',
                    controller: 'ObjectTestSettingDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ObjectTestSetting', function($stateParams, ObjectTestSetting) {
                    return ObjectTestSetting.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('object-test-setting-clone', {
            parent: 'object-test-setting',
            url: '/{id}/clone',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-dialog.html',
                    controller: 'ObjectTestSettingDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ObjectTestSetting', function($stateParams, ObjectTestSetting) {
                    return ObjectTestSetting.getClone({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('object-test-setting.delete', {
            parent: 'object-test-setting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-delete-dialog.html',
                    controller: 'ObjectTestSettingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ObjectTestSetting', function(ObjectTestSetting) {
                            return ObjectTestSetting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('object-test-setting', null, { reload: 'object-test-setting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('object-test-setting-edit-tag', {
            parent: 'object-test-setting',
            url: '/edit-tag',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.objectTestSetting.home.edit'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-edit-tag.html',
                    controller: 'EditTagController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectTestSetting');
                    return $translate.refresh();
                }]
            }
        })
        .state('object-test-setting-edit-tag.delete', {
            parent: 'object-test-setting-edit-tag',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-test-setting/object-test-setting-tag-delete-dialog.html',
                    controller: 'DeleteTagController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TestSettingTag', function (TestSettingTag) {
                            return TestSettingTag.get({id: $stateParams.id});
                        }],
                    }
                }).result.then(function () {
                    $state.go('object-test-setting-edit-tag', null, {reload: true});
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }

})();
